import styled from "styled-components";
import bannerSrc from "../../assets/images/banner-sobre.jpeg";
import { Footer } from "../../components/Footer";
import { Header } from "../../components/Header";
import { MainBanner } from "../../components/MainBanner";
import { Newsletter } from "../../components/Newsletter";
import { Title } from "../../components/Title";
import { Container } from "../../theme/styles";
import { Coordinator } from "./components/Coordinator";
import { Omv } from "./components/Omv";
import { Counselor } from "./components/Counselor";
import { useOmv } from "../../hooks/useOmv";
import { useCoordinaion } from "../../hooks/useCoordination";
import { useCouncil } from "../../hooks/useCouncil";
import { Slider } from "../../components/Slider";
import { usePageTrack } from "../../hooks/useAnalyticsPageTracker";


function About() {
  const omv = useOmv();
  const coordinators = useCoordinaion();
  const council = useCouncil();
  usePageTrack();
  return (
    <>
      <Header />
      <MainBanner bannerSrc={bannerSrc} />
      <Content>
        <OmvList>
          {omv.map((item, index) => <Omv key={index} omv={item} />)}
        </OmvList>
      </Content>
      <Staff>
        <Container>
          <Title title="Coordenação" hasSpacing={true} />
          <CoordinatorList>
            {coordinators.map((item, index) => <Coordinator key={index} coordinator={item} />)}
          </CoordinatorList>
          <Title title="Conselho Científico" hasSpacing={true} />
          <CounselorList>
            {council.map((item, index) => <Counselor key={index} counselor={item} />)}
          </CounselorList>
          <SliderOuter>
            <Slider>
              {council.map((item, index) => <Counselor key={index} counselor={item} />)}
            </Slider>
          </SliderOuter>
        </Container>
      </Staff>
      <Newsletter />
      <Footer />
    </>
  );
}

export default About;

const Content = styled(Container)`
  padding: 64px 0;

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    padding: 32px 0 0;
  }
`;

const OmvList = styled.div`
  display: flex;

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    flex-direction: column;
  }
`;

const Staff = styled.div`
  background-color: ${({ theme }) => theme.colors.gray.light};
  padding-bottom: 50px
`;

const CoordinatorList = styled.ul`
  list-style-type: none;
  display: flex;
  justify-content: center;

  @media screen and (max-width: ${({ theme }) => theme.device.mobile}) {
    flex-direction: column;
  }
`;

const CounselorList = styled.ul`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 100px;
  
  @media screen and (max-width: ${({ theme }) => theme.device.screen}) {
    gap: calc(10vw - 68px);
  }

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    display: none;
  }
`;

const SliderOuter = styled.div`
  padding-bottom: 32px;
  display: none;
  
  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    display: block;
  }
`;
